export default {
    S1: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'get insights and perspectives', // e.g., "get insights and perspectives" 
        'siteSection': 'get insights and perspectives', // e.g., "get insights and perspectives"
       },
    S2: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'See how we\'re making an impact', // e.g., "get insights and perspectives" 
        'siteSection': 'See how we\'re making an impact', // e.g., "get insights and perspectives"
    },
    S3: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'track our sustainable finance progress', // e.g., "get insights and perspectives" 
        'siteSection': 'track our sustainable finance progress', // e.g., "get insights and perspectives"
    },
    S4: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'see how our work is making headlines', // e.g., "get insights and perspectives" 
        'siteSection': 'see how our work is making headlines', // e.g., "get insights and perspectives"
    },
    S5: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'additional resources', // e.g., "get insights and perspectives" 
        'siteSection': 'additional resources', // e.g., "get insights and perspectives"
    },
    S6: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'map', 
        'siteSection': 'map',
    },
    S7: {
        'event': 'scroll',
        'scrollType': 'section',
        'scrollSection': 'we\'re committed to our communities', // e.g., "get insights and perspectives" 
        'siteSection': 'we\'re committed to our communities', // e.g., "get insights and perspectives"
    },
    C1: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'get insights and perspectives', // e.g., "get insights and perspectives" 
        'clickText': '{{lower case story title}}' //e.g., "Making the shift to EVs is getting more affordable"
    }, 
    C2: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'load more',
        'buttonLocation': 'bottom', 
        'siteSection': 'get insights and perspectives', // e.g. "get insights and perspectives"
        'clickText': '{{lower case click text}}', //e.g., "load more stories", "load more headlines", etc.
    }, 
    C3: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'watch',
        'buttonLocation': 'bottom', 
        'siteSection': 'see how we\'re making an impact', 
        'clickText': '{{lower case title OR subtitle}}' // e.g., "Spotlight: AES" OR "this invention could reduce the carbon footprint of old buildings"
    }, 
    C4: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'view report',
        'buttonLocation': 'bottom', 
        'siteSection': 'track our sustainable finance progress', 
        'clickText': 'view report: {{lower case subtitle}}'  //  e.g., "view report: providing financing with sustainability bonds"
    }, 
    C5: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'view story',
        'buttonLocation': 'bottom', 
        'siteSection': 'see how our work is making headlines', 
        'clickText': '{{publication title}}: {{lower case story title}}'  //  e.g., "forbes: finance 30 under 30 "
    }, 
    C6: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'additional resources', 
        'clickText': '{{lower case item title}}'  //  e.g., "co2emission"
       }, 
    C7: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': '{{lowercase user input}}', // e.g., "90210", "new york", etc.
     }, 
    C8: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'map interaction',
        'buttonLocation': 'mid', 
        'siteSection': 'map',
        'clickText': '{{lowercase cause type}}', // e.g., "environment"
    }, 
    C9: {
        'event': 'key-interaction',
        'lineOfBusiness': 'ent: interaction',
        'userActionTaken': 'learn more',
        'buttonLocation': 'mid', 
        'siteSection': 'we\'re committed to our communities',
        'clickText': 'learn more about the other ways we’re stepping up in our local neighborhoods' 
    }      
}